import { RELOAD_TYPES } from "@/static/reloadTypes";
import { Expose, Type, TypeHelpOptions } from "class-transformer";
import { IsBoolean, IsEnum, IsOptional, IsString, ValidateNested } from "class-validator";

export class CommandResponseBookingItemTmpId {
  @IsString()
  @Expose()
  bookingItemTmpId!: string;
}

export class CommandResponseCanMergeBookings {
  @IsString()
  @Expose()
  recordLocator!: string; // "WNT-A46AC815A",
  @IsString()
  @Expose()
  createdAt!: string; //"2021-03-27T16:36:15"
}

export class CommandResponseTradeTermIsPercentage {
  @IsBoolean()
  @Expose()
  tradeTermIsPercentage!: boolean;
  @IsString()
  @Expose()
  orderItemId!: string;
}
export class CheckBeforeSaveCommandResponse {
  @IsBoolean()
  @Expose()
  isEditingLocked!: boolean;
  @IsBoolean()
  @Expose()
  hasPermission!: boolean;
}

// eslint-disable-next-line @typescript-eslint/ban-types
function commandResponseTypeChecker(val: TypeHelpOptions | undefined): Function {
  if (typeof val !== "undefined") {
    // eslint-disable-next-line
    const commandResponse = val.object.commandResponse as any;
    if (commandResponse !== null) {
      if (typeof commandResponse.bookingItemTmpId !== "undefined") {
        return CommandResponseBookingItemTmpId;
      }
      if (typeof commandResponse.recordLocator !== "undefined") {
        return CommandResponseCanMergeBookings;
      }
      if (typeof commandResponse.tradeTermIsPercentage !== "undefined") {
        return CommandResponseTradeTermIsPercentage;
      }
      if (typeof commandResponse.isEditingLocked !== "undefined") {
        return CheckBeforeSaveCommandResponse;
      }
    }
  }
  return () => {
    return null;
  };
}

export class OperationResult {
  @IsString()
  @Expose()
  operationId!: string;

  @IsEnum(RELOAD_TYPES, { each: true })
  @Expose()
  reload!: Array<RELOAD_TYPES>;

  @Expose()
  @IsOptional()
  @IsBoolean()
  scrollToEndList: boolean | null = null;

  @IsOptional()
  @Type(commandResponseTypeChecker)
  @ValidateNested()
  @Expose()
  commandResponse!:
    | null
    | CommandResponseBookingItemTmpId
    | CommandResponseCanMergeBookings
    | CommandResponseTradeTermIsPercentage
    | CheckBeforeSaveCommandResponse;
}
